import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { ProcessType } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class ProcessTypesService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getProcessTypes(): Observable<ProcessType[]> {
        return this.http.get<ProcessType[]>(
            `${this.config.getConfiguration().API_BASE}/processtype`,
        );
    }

    getProcessType(processTypeId: string): Observable<ProcessType> {
        return this.http.get<ProcessType>(
            `${
                this.config.getConfiguration().API_BASE
            }/processtype/${processTypeId}`,
        );
    }

    updateProcessType(processType: ProcessType): Observable<ProcessType> {
        return this.http.put<ProcessType>(
            `${this.config.getConfiguration().API_BASE}/processtype/${
                processType.code
            }`,
            processType,
        );
    }
}
